/**
 * Maps an event name to a message type
 * @param eventName The event name to convert
 * @returns The corresponding message type
 */
export const getMessageTypeFromEventName = (eventName: string): string => {
  switch (true) {
    case eventName.startsWith('thinking'):
      return 'llm_thinking';
    case eventName.startsWith('text'):
      return 'llm_text';
    case eventName.startsWith('tool_call'):
      return 'llm_tool';
    case eventName.startsWith('response'):
      return 'llm_response';
    default:
      return 'llm_text'; // Default to text for unknown event types
  }
};
